import { AuditAudio } from '@mi-front/core';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { useState } from 'react';
import { defineMessage, FormattedMessage, useIntl } from 'react-intl';
import { RowActionMui } from '../../../../../components/table/RowActionMui';
import { ShowTranscriptionDialogContent } from './ShowTranscriptionDialogContent';

const showTranscriptionMessage = defineMessage({
  id: 'audit.audiosScreen.showTranscription',
  defaultMessage: 'Mostrar transcripción',
});

const transcriptionTitleMessage = defineMessage({
  id: 'audit.audiosScreen.transcriptionTitle',
  defaultMessage: 'Transcripción de {customId}',
});

/**
 * Opens a dialog with the transcription and reference media player for an audio.
 */
export function ShowTranscriptionAction({
  stationId,
  audio,
  transcription,
}: {
  stationId: string;
  audio: Pick<AuditAudio, 'id' | 'customId' | 'title' | 'duration' | 'filename'>;
  transcription: NonNullable<AuditAudio['transcription']>;
}) {
  const { $t } = useIntl();
  const [open, setOpen] = useState(false);

  return (
    <>
      <RowActionMui title={$t(showTranscriptionMessage)} onClick={() => setOpen(true)}>
        <ArticleOutlinedIcon />
      </RowActionMui>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
        disableEnforceFocus
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ArticleOutlinedIcon />
          <FormattedMessage {...transcriptionTitleMessage} values={{ customId: audio.customId }} />
          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={() => setOpen(false)} sx={{ my: 0 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ py: 4 }}>
          <ShowTranscriptionDialogContent
            stationId={stationId}
            audio={audio}
            transcription={transcription}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
